import axios from "axios";
import Events from "../utilities/EventEmitter";
import appConstant from "../appConstants";
// import * as  mockAPI from "./mock"

const getAPIPath = (apiName) => {
  switch (apiName) {
    case "GetConfiguration":
      return "/api/Settings/getWebAppConfig";
    case "ShipmentsGrid":
      return "/api/Shipment/GetAllShipments";
    case "IBShipmentsGrid":
      return "/api/Shipment/GetPlannedShipments";
    case "RoutesGrid":
      return "/api/Route/GetRoutes";
    case "StopsGrid":
      return "/api/Stop/GetRouteStops";
    case "SetRouteTermination":
      return "/api/Route/SetRouteTermination";
    case "GetNearbyRoutes":
      return "/api/Route/GetNearbyRoutes";
    case "MergeRoutes":
      return "/api/Route/MergeRoutes";
    case "CreateRoute":
      return "/api/Route/CreateRoute";
    case "ConvertRoutes":
      return "/api/Route/ConvertRoutes";
    case "UpdateLastStop":
      return "/api/Stop/UpdateLastStop";
    case "UpdateStopSequence":
      return "/api/Stop/UpdateStopSequence";
    case "UpdateRouteStops":
      return "/api/Stop/UpdateRouteStops";
    case "UpdateRouteStopTime":
      return "/api/Stop/UpdateRouteStopTime";
    case "runTSP":
      return "/api/engine/RunTSP";
    case "UpdateRoutes":
      return "/api/Route/UpdateRoutes";
    case "UpdateRouteStopsFromMap":
      return "/api/Stop/UpdateRouteStopsFromMap";
    case "UpdateShipmentsProperty":
      return "/api/Shipment/UpdateShipmentsProperty";
    case "UpdateShipmentRouteAssignment":
      return "/api/Shipment/UpdateShipmentRouteAssignment";
    case "GetParameters":
      return "/api/Settings/GetParameters";
    case "UpdateParameters":
      return "/api/Settings/UpdateParameters";
    case "GetStemMiles":
      return "/api/Settings/GetSpeedProfileForStemMile";
    case "UpdateStemMiles":
      return "/api/Settings/UpdateSpeedProfileForStemMile";
    case "DeleteStemMiles":
      return "/api/Settings/DeleteSpeedProfileForStemMile";
    case "GetZoneMiles":
      return "/api/Settings/GetSpeedProfileForZoneMile";
    case "UpdateZoneMiles":
      return "/api/Settings/UpdateSpeedProfileForZoneMile";
    case "DeleteZoneMiles":
      return "/api/Settings/DeleteSpeedProfileForZoneMile";
    case "GetWaves":
      return "/api/Settings/GetWaveDetails";
    case "UpdateWave":
      return "/api/Settings/UpdateWave";
    case "DeleteWave":
      return "/api/Settings/DeleteWave";
    case "GetAllTrailers":
      return "/api/Settings/GetAllTrailers";
    case "GetAllTractors":
      return "/api/Settings/getAllTractors";
    case "UpdateTrailers":
      return "/api/Settings/UpdateTrailers";
    case "GetScenarios":
      return "/api/Settings/GetScenarios";
    case "CopyScenario":
      return "/api/Settings/CopyScenario";
    case "EditScenario":
      return "/api/Settings/EditScenario";
    case "GetAnchorPoints":
      return "/api/Settings/GetAnchorPoints";
    case "UpdateRouteAnchorPoint":
      return "/api/Route/UpdateRouteAnchorPoint";
    case "UpdateAnchorPoint":
      return "/api/Settings/UpdateAnchorPoint";
    case "IBKPIs":
      return "/api/KPIs/GetIBKPIs";
    case "GetQuickFilters":
      return "/api/User/GetQuickFilters";
    case "GetUserInfo":
      return "/api/User/GetUserInfo";
    case "SetUserPreferences":
      return "/api/User/SetUserPreferences";
    case "UpdateFirstStop":
      return "/api/Stop/UpdateFirstStop";
    case "TriggerDynamicRouting":
      return "/api/Engine/TriggerDynamicRouting";
    case "GetUNRTDReasons":
      return "/api/Route/GetUNRTDReasons";
    case "PublishRoutes":
      return "/api/routes/publish";
    case "GetAllUsers":
      return "/api/User/GetAllUsers";
    case "GetAllTerminals":
      return "/api/User/GetAllTerminals";
    case "CreateUserPasswordFlow":
      return "/api/User/createUserPasswordFlow";
    case "CreateUserEmailFlow":
      return "/api/User/createUserEmailFlow";
    case "UpdateUser":
      return "/api/User/updateUser";
    case "DeleteUser":
      return "/api/User/deleteUser";
    case "GetTerminalKPIGoals":
      return "/api/Settings/GetTerminalKPIGoals";
    case "UpdateTerminalKPIGoals":
      return "/api/Settings/UpdateTerminalKPIGoals";
    case "UpdateShipmentCustomerLocation":
      return "/api/Customer/UpdateCustomerLocation";
    case "GetEnabledFeaturesByTerminal":
      return "/api/Settings/GetEnabledFeaturesByTerminal";
    case "GetDriverPreferences":
      return "/api/Settings/GetDriverPreferences";
    case "UpdateDriverPreferences":
      return "/api/Settings/UpdateDriverPreferences";
    case "Undo":
      return "/api/route/Undo";
    case "GetNewShipments":
      return "/api/shipment/GetNewShipments";
    case "GetAllNotifications":
      return "/api/Notification/GetAllNotifications";
    case "CreateOrUpdateNotification":
      return "/api/Notification/CreateOrUpdateNotification";
    case "DeleteNotification":
      return "/api/Notification/DeleteNotification";
    case "GetActiveNotificationForUser":
      return "/api/Notification/GetActiveNotificationForUser";
    case "DisableNotification":
      return "/api/Notification/DisableNotification";
    case "GetPublishedTerminals":
      return "/api/Reports/GetPublishedTerminals";
    case "CreateAnchorPoint":
      return "/api/Settings/createAnchorPoint";
    case "DeleteAnchorPoint":
      return "/api/Settings/deleteAnchorPoint";
    case "UpdateCustomerTrailerLengthPreference":
      return "/api/customer/updateCustomerProperties";
    case "GetRouteMapping":
      return "/api/settings/getRouteMapping";
    case "DeleteRouteMapping":
      return "/api/settings/deleteRouteMapping";
    case "saveRouteMapping":
      return "/api/settings/saveRouteMapping";
    case "CopyRouteMapping":
      return "/api/settings/copyRouteMapping";
    case "GetDoorData":
      return "/api/settings/getDoorData";
    case "MergeCustomers":
      return "/api/customer/mergeCustomers";
    case "MergeShippers":
      return "/api/customer/mergeShippers";
    case "GetRouteComplianceData":
      return "/api/reporting/getRouteComplianceData";
    case "GetNextStopComplianceGridData":
      return "/api/reporting/getNextStopComplianceGridData";
    case "GetRouteComplianceKPI":
      return "/api/reporting/getRouteComplianceKPI";
    case "GetLatestNSCReportDate":
      return "/api/reporting/getLatestNSCReportDate";
    case "GetShipperConsignee":
      return "/api/citydispatch/getShipperConsignee";
    case "ValidatePro":
      return "/api/citydispatch/validatePro";
    case "GetLocationMapping":
      return "/api/citydispatch/getLocationMapping";
    case "GetBolDetails":
      return "/api/citydispatch/getBolDetails";
    case "GetClientCodes":
      return "/api/settings/getClientCodes";
    case "DeleteHoliday":
      return "/api/holiday/deleteHoliday";
    case "GetAllHolidays":
      return "/api/holiday/getAllHolidays";
    case "SaveHoliday":
      return "/api/holiday/saveHoliday";
    case "GetAllDropYard":
      return "/api/settings/getDropYard";
    case "SaveDropYard":
      return "/api/settings/saveDropYardRegion"
    case "DeleteDropYard":
      return "/api/settings/deleteDropYardRegion"
    /* DCR APIs */
    case "GetDockComplianceReport":
      return "/api/Reports/getComplianceData";
    case "GetDockComplianceLatestReportDate":
      return "/api/reports/getLatestDCReportDate";
    case "GetShipmentDetails":
      return "/api/Reports/getShipmentDetails";
    case "GetDockComplianceKPIs":
      return "/api/Reports/getComplianceKPI";
    /* End DCR APIs */

    case "PrintLoadingManifest":
      return "/api/Route/PrintLoadingManifest";
    case "GetRouteEquipmentPreference":
      return "/api/Settings/GetRouteTrailerPreference";
    case "UpdateRouteEquipmentPreference":
      return "/api/Settings/UpdateRouteTrailerPreference";
    case "GetProHistory":
      return "/api/Reports/GetProHistory";
    case "GetPlanningKPIReportCharts":
      return "/api/ibpreporting/getIBPlanningKPIForDateRange";
    case "GetPlanningKPIReportForRoutes":
      return "/api/Reports/getKPIReportForRoutes";
    case "GetDuplicateCustomer":
      return "/api/Reports/getDuplicateCustomer";
    case "GetDispatchKPIReportCharts":
      return "/api/reporting/getDispatchKPIForDateRange";
    case "GetDispatchKPIReportForRoutes":
      return "/api/reporting/getRouteLevelKpi";

    /*Excel Upload APIs */
    case "inputShipment":
      return "/filedata/upload/inputShipments";
    case "trailer":
      return "/filedata/upload/trailerInventory";
    case "wave":
      return "/filedata/upload/prePlanningData";
    case "anchor":
      return "/filedata/upload/anchorPoints";
    case "driver":
      return "/filedata/upload/driverPreference";
    case "customerSplInst":
      return "/filedata/upload/customerSpecialInstruction";
    case "freightBill":
      return "/filedata/upload/freightBillDetails";
    case "GetFreightBillDetails":
      return "/api/citydispatch/getFreightBillDetails";
    case "UpdateGeofenceData":
      return "/api/Settings/updateGeofencingData";
    case "GetGeofenceData":
      return "/api/Settings/getGeofencingData";
    case "DispatchedDrivers":
      return "/api/citydispatch/getAllDispatchRoutes";
    case "DispatchTractors":
      return "/api/citydispatch/getTractors";
    case "UpdateTractorForDispatch":
      return "/api/citydispatch/updateTractorForDispatch";
    case "UpdateDriverForDispatch":
      return "/api/citydispatch/updateDriverForDispatch";
    case "GetDispatchFilter":
      return "/api/citydispatch/getDispatchFilter";
    case "PickupsGrid":
      return "/api/citydispatch/getAllPickups";
    case "Recommendations":
      return "/api/citydispatch/getDispatchRouteRecommendations";
    case "CancelDispatch":
      return "/api/dispatch/app/dispatchCancel";
    case "AssignPickup":
      return "/api/dispatch/app/pickup/assign";
    case "UnassignPickup":
      return "/api/dispatch/app/pickup/unassign";
    case "ReassignPickup":
      return "/api/dispatch/app/pickup/reassign";
    case "AssignDriver":
      return "/api/dispatch/app/assignDriver";
    case "UpdatePickupStop":
      return "/api/dispatch/app/manifest/pickupCompleted";
    case "NoFreightPickedUp":
      return "/api/dispatch/app/manifest/noFreightPickedUp";
    case "CompleteDeliveryStop":
      return "/api/dispatch/app/manifest/deliveryCompleted";
    case "UpdatePickupData":
      return "/api/citydispatch/updatePickupData";
    case "PickupOptimize":
      return "/api/dispatch/app/pickup/optimize";
    case "GetAllMessages":
      return "/api/citydispatch/getAllMessages";
    case "MessageToDriver":
      return "/api/dispatch/app/message/messageToDriver";
    case "ProjectedDispatchKPI":
      return "/api/citydispatch/getProjectedKPI";
    case "DispatchKPI":
      return "/api/citydispatch/getDispatchKPI";
    case "getClientData":
      return "/api/citydispatch/getClientCodes";
    case "getAllPackageCodes":
      return "/api/citydispatch/getAllPackageCodes";
    case "GetAllHazmatInfo":
      return "/api/citydispatch/getAllHazmatInfo";
    case "TrailersList":
      return "/api/citydispatch/getTrailers";
    case "TrailerHook":
      return "/api/dispatch/app/TrailerHook";
    case "TrailerDrop":
      return "/api/dispatch/app/TrailerDrop";
    case "Bobtail":
      return "/api/dispatch/app/Bobtail";
    case "MoveBills":
      return "/api/dispatch/app/MoveBills";
    case "DispatcherReadReceipt":
      return "/api/dispatch/app/message/dispatcherReadReceipt";
    case "VoidPickup":
      return "/api/dispatch/app/pickup/void";
    case "UpdatePickupCustomerLocation":
      return "/api/dispatch/app/pickup/updateShipperLocation";
    case "UpdateDeliveryCustomerLocation":
      return "/api/dispatch/app/customer/updateCustomerLocation";
    case "saveDispatchStopSequence":
      return "/api/dispatch/app/manifest/stopMove";
    case "GetDispatchGroupMessages":
      return "/api/citydispatch/getGroupMessages";
    case "SendDispatchGroupMessages":
      return "/api/dispatch/app/message/sendGroupMessage";
    /* CustomerManagement APIs */
    case "GetCustomerDetail":
      return "/api/customer/getCustomerDetail";
    case "UpdateCustomerDetail":
      return "/api/customer/updateCustomerDetail";
    case "GetCustomerRoutes":
      return "/api/customer/getCustomerRoutes";
    case "GetUnreadMessages":
      return "/api/citydispatch/getUnreadMessages";
    case "saveDispatchRouteStopResequence":
      return "/api/dispatch/app/manifest/stopMove";
    case "GetAllEquipment":
      return "/api/citydispatch/getAllEquipment";
    case "GetAvailableDrivers":
      return "/api/citydispatch/getScheduledDrivers";
    case "DispatchDriver":
      return "/api/dispatch/app/dispatchDriver";
    case "GetAllRouteNamesForTerminal":
      return "/api/citydispatch/getAllRouteNamesForTerminal";
    case "DriverPerformance":
      return "/api/reporting/getDriverPerformanceReport";
    case "RemovePro":
      return "/api/dispatch/app/manifest/deletePro";
    case "StopsCompleted":
      return "/api/dispatch/app/manifest/stopsCompleted";
    case "EndOfTrip":
      return "/api/dispatch/app/EndOfTrip";
    case "AddPro":
      return "/api/dispatch/app/manifest/addPro";
    case "GetProDetails":
      return "/api/citydispatch/getShipment";
    case "MarkAsNextStop":
      return "/api/dispatch/app/manifest/nextStopChanged";
    case "CustomerReceiver":
      return "/api/citydispatch/getCustomerReceiver";
    case "GetTerminalsToMovePickup":
      return "/api/citydispatch/getTerminalsToMovePickup";
    case "UpdatePickupTerminal":
      return "/api/dispatch/app/pickup/updatePickupTerminal";
    case "DriverPerformanceHistoricData":
      return "/api/reporting/getHistoricalDriverPerformanceReport";
    case "GetShippersAtTerminal":
      return "/api/cityDispatch/getShippersAtTerminal";
    case "GetAllAppTerminals":
      return "/api/citydispatch/getAllTerminals";
    case "CreatePickup":
      return "/api/dispatch/app/pickup/createPickup";
    case "EditPickup":
      return "/api/dispatch/app/pickup/editPickup";
    case "MergePickup":
      return "/api/dispatch/app/pickup/mergePickup";
    case "PickupRestrictions":
      return "/api/citydispatch/getPickupRestrictions";
    case "DeleteMergedCustomers":
      return "/api/customer/deleteMergedCustomers";
    case "GetMergedCustomers":
      return "/api/reports/getMergedCustomers";
    case "GetImages":
      return "/api/citydispatch/getStopImagesBlob";
    case "GetDriverImages":
      return "/api/citydispatch/getDriverImagesBlob";
    case "SpottedTrailer":
      return "/api/citydispatch/getSpottedTrailers";
    case "StopChangeHistory":
      return "/api/citydispatch/getStopChangeHistory";
    case "GetDuplicatePickups":
      return "/api/citydispatch/getAllDuplicatePickups";
    case "GetReturnShipments": 
      return "/api/citydispatch/getReturnShipments";
    // Shipment Selection APIs
    case "GetReturnShipmentsForPlan":
      return "/api/shipmentselection/getReturnShipments"
    case "GetInboundBills":
      return "/api/shipmentselection/getInboundBills"
    case "AddShipmentsToPlan":
      return "/api/shipmentselection/addShipmentsToPlan";
    case "GetInitializedPlanDates":
      return "/api/shipmentselection/getInitializedPlanDates"
    case "GetValidHolidays":
      return "/api/holiday/getValidHolidays"; 
    case "GetStagingEvents":
      return "/api/reports/getStagingEvents";
    case "getDynamicRoutingUsageReport":
      return "/api/ibpreporting/getDynamicRoutingUsageReport";
    case "GetFeederTerminal":
      return "/api/settings/getFeederTerminal";
    case "UpdateFeederTerminal":
      return "/api/settings/saveFeederTerminal";
    case "GetShipmentsToAdd":
      return "/api/shipmentselection/getShipmentsToAdd";
    case "UpdateProNotes": 
      return "/api/dispatch/app/addProNotes";
    case "SaveTerminal":
       return "/api/settings/loadTerminal";
    case "AddProToCompletedPickup": 
      return "/api/dispatch/app/manifest/addProToCompletedPickup"
    default:
      return "";
  }
};
export const getDataWithQueryString = (apiName, queryString, options) => {
  const url = queryString
    ? `${getAPIPath(apiName)}?${queryString}`
    : getAPIPath(apiName);
  return axios.get(url, options).then((response) => response);
};

export const postData = (apiName, dataObject) => {
  return axios.post(getAPIPath(apiName), dataObject).then((response) => {
    if (response && response.response && response.response.status === 409) {
      Events.emit(appConstant.Event.RESTOREIBSTORE);
    }
    return response;
  });
};

export const getCancelToken = () => axios.CancelToken;
